import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "typeField"]

  updateType() {
    const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]

    if (selectedOption && selectedOption.dataset.type) {
      this.typeFieldTarget.value = selectedOption.dataset.type
    } else {
      this.typeFieldTarget.value = ""
    }
  }
}
